import React, {useCallback, useEffect, useRef, useState} from 'react';
import Checkbox from "../../../../../components/checkbox";
import _ from "lodash";
import {useList} from "react-use";

import {Collapse} from 'react-collapse';

function PointDifference(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected, error} = props;
    const [totalCondition, setTotalCondition] = useState({
        diffIds: selected.diffIds,
        score: selected.score,
        uplow: selected.uplow
    })
    const [checkScore, setCheckScore] = useState(false);
    const scoreRef = useRef();
    const [listDiff, listDiffHelper] = useList([
        {
            value: 1,
            name: 'リード',
            checked: false
        }, {
            value: 2,
            name: 'ビハインド',
            checked: false
        }, {
            value: 3,
            name: '同点',
            checked: false
        },
    ]);
    const [isCheckUp, setIsCheckUp] = useState(selected.uplow && selected.uplow === 1 ? true : false);
    const [isCheckLow, setIsCheckLow] = useState(selected.uplow && selected.uplow === 2 ? true : false);

    useEffect(() => {
        if (selected.diffIds.length > 0) {
            selected.diffIds.map(item => {
                const index = listDiff.findIndex(i => i.value === item);
                listDiff[index].checked = true;
            })
        }
    }, [selected])

    useEffect(() => {
        props.onChange(totalCondition)
    }, [totalCondition])

    useEffect(() => {
        setCheckScore(totalCondition.uplow !== null ? true : false);
        setIsCheckUp(totalCondition.uplow === 1 ? true : false);
        setIsCheckLow(totalCondition.uplow === 2 ? true : false);
    }, [totalCondition.uplow])

    useEffect(() => {
        if (selected.score) {
            scoreRef.current.value = selected.score.toString().concat('点');
        }
    }, [selected])

    const onClickDiff = useCallback((val, i) => {
        listDiffHelper.updateAt(i, {...listDiff[i], checked: !listDiff[i].checked})
        const arr = [...totalCondition.diffIds];
        const index = _.indexOf(arr, Number(val));
        if (index === -1) {
            arr.push(Number(val));
        } else {
            arr.splice(index, 1);
        }
        setTotalCondition(state => ({...state, diffIds: arr}));
    }, [totalCondition.diffIds])

    const onCheckScore = useCallback(() => {
        setCheckScore(!checkScore);
        if (!checkScore) {
            setTotalCondition(state => ({...state, uplow: (!isCheckUp && !isCheckLow) ? 1 : totalCondition.uplow}));
            const score = Number(scoreRef.current.value.replace('点', ''));
            setTotalCondition(state => ({...state, score: state.score ? null : score}));
            return;
        }
        setIsCheckUp(false);
        setIsCheckLow(false);
        setCheckScore(false);
        setTotalCondition(state => ({...state, score: null, uplow: null}))
    }, [checkScore])

    const onChangeScore = useCallback((e) => {
        if (checkScore) {
            const score = Number(e.target.value.replace('点', ''));
            setTotalCondition(state => ({...state, score: score}));
        }
    }, [checkScore])

    const onCheckUp = useCallback((val) => {
        setIsCheckUp(true);
        setIsCheckLow(false);
        setTotalCondition(state => ({...state, uplow: val}));
        if (!checkScore) {
            const score = Number(scoreRef.current.value.replace('点', ''));
            setTotalCondition(state => ({...state, score: state.score ? null : score}));
            return;
        }
    }, [checkScore])
    const onCheckLow = useCallback((val) => {
        setIsCheckUp(false);
        setIsCheckLow(true);
        setTotalCondition(state => ({...state, uplow: val}));
        if (!checkScore) {
            const score = Number(scoreRef.current.value.replace('点', ''));
            setTotalCondition(state => ({...state, score: state.score ? null : score}));
            return;
        }
    }, [checkScore])

    return (
        <div className='inner-item-child advance-search group-filter-item'>
            <div className={'open-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>点差</h4>
                    <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
                </div>
                <Collapse isOpened={isOpened}>
                    <div className='d-block'>
                        <div className='d-flex-align-center'>
                            {listDiff.map((item, index) => {
                                return (
                                    <div key={item.value} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.checked} onClick={() => onClickDiff(item.value, index)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='d-flex-align-center'>
                            <div className='search-main-point-difference-checkbox'>
                                <label>
                                    <Checkbox onClick={onCheckScore} checked={selected.score && true}/>
                                </label>
                            </div>
                            <select className='form-control select-custome' ref={scoreRef} onChange={onChangeScore}>
                                <option>1点</option>
                                <option>2点</option>
                                <option>3点</option>
                            </select>
                            <div className='item-select'>
                                <label className="radio-detailed-search">以上
                                    <input type="radio" checked={isCheckUp}
                                           onClick={() => onCheckUp(1)}/>
                                    <span className="checkmark">
                                </span>
                                </label>
                            </div>
                            <div className='item-select'>
                                <label className="radio-detailed-search">以内
                                    <input type="radio" checked={isCheckLow}
                                           onClick={() => onCheckLow(2)}/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className=' err-validate-advance' style={{paddingTop: 30}}>
                        {error && <h4 className='navbar-item err-label'
                                      style={{paddingLeft: 20, paddingBottom: 10}}>点差{error.message}</h4>}
                    </div>
                </Collapse>
            </div>
            <div className={'close-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>点差</h4>
                </div>

                    <div className='d-block'>
                        <div className='d-flex-align-center'>
                            {listDiff.map((item, index) => {
                                return (
                                    <div key={item.value} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.checked} onClick={() => onClickDiff(item.value, index)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='d-flex-align-center'>
                            <div className='search-main-point-difference-checkbox'>
                                <label>
                                    <Checkbox onClick={onCheckScore} checked={selected.score && true}/>
                                </label>
                            </div>
                            <select className='form-control select-custome' ref={scoreRef} onChange={onChangeScore}>
                                <option>1点</option>
                                <option>2点</option>
                                <option>3点</option>
                            </select>
                            <div className='item-select'>
                                <label className="radio-detailed-search">以上
                                    <input type="radio" checked={isCheckUp}
                                           onClick={() => onCheckUp(1)}/>
                                    <span className="checkmark">
                                </span>
                                </label>
                            </div>
                            <div className='item-select'>
                                <label className="radio-detailed-search">以内
                                    <input type="radio" checked={isCheckLow}
                                           onClick={() => onCheckLow(2)}/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className=' err-validate-advance' style={{paddingTop: 30}}>
                        {error && <h4 className='navbar-item err-label'
                                      style={{paddingLeft: 20, paddingBottom: 10}}>点差{error.message}</h4>}
                    </div>
            </div>

        </div>
    )
}

export default PointDifference;
